var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.$wf.isSmDown
    ? _c(
        "w-menu",
        {
          attrs: { "close-on-blur": "", "close-on-click": "", right: "" },
          model: {
            value: _vm.reportsDropDownOpen,
            callback: function ($$v) {
              _vm.reportsDropDownOpen = $$v
            },
            expression: "reportsDropDownOpen",
          },
        },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.reports"),
                  expression: "$ct('tooltip.reports')",
                },
              ],
              style: { paddingLeft: _vm.withPrintingButton ? "15px" : "15px" },
              attrs: { slot: "activator", disabled: !_vm.isEnabled },
              slot: "activator",
            },
            [
              _c("w-fa", {
                attrs: {
                  icon: _vm.withPrintingButton ? "file-alt" : "file-alt",
                },
              }),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.reportsDropDownOpen && _vm.isEnabled
                ? _c(
                    "w-scroll-view",
                    {
                      staticClass: "w-dropdown-select-items",
                      attrs: { "rounded-top": "", "rounded-bottom": "" },
                    },
                    [
                      _vm._l(
                        _vm.state.savedReportSettings,
                        function (savedReport, i) {
                          return _c(
                            "div",
                            {
                              key: "d" + i,
                              staticClass:
                                "w-dropdown-select-item saved-report",
                              attrs: { tabindex: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.printReport(savedReport)
                                },
                              },
                            },
                            [
                              _c("w-row", [
                                _vm._v(" " + _vm._s(savedReport.Name) + " "),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                      _vm.state.savedReportSettings.length > 0
                        ? _c("div", { staticClass: "seperator" })
                        : _vm._e(),
                      _vm._l(
                        _vm.state.staticReportSettings,
                        function (staticReport, i) {
                          return _c(
                            "div",
                            {
                              key: "s" + i,
                              staticClass:
                                "w-dropdown-select-item static-report",
                              attrs: { tabindex: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.printReport(staticReport)
                                },
                              },
                            },
                            [
                              _c("w-row", [
                                _vm._v(" " + _vm._s(staticReport.Name) + " "),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                      _vm.state.staticReportSettings.length > 0
                        ? _c("div", { staticClass: "seperator" })
                        : _vm._e(),
                      _vm._l(_vm.visibleCustomReportButtons, function (btn, i) {
                        return _c(
                          "div",
                          {
                            key: "crb-" + i,
                            staticClass: "w-dropdown-select-item",
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.openCustomReportButton(btn)
                              },
                            },
                          },
                          [
                            _c(
                              "w-row",
                              { attrs: { center: "" } },
                              [
                                _c("w-fa", {
                                  staticClass: "mr",
                                  attrs: {
                                    icon: btn.Icon || "external-link-alt",
                                  },
                                }),
                                _vm._v(" " + _vm._s(btn.Name) + " "),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm.visibleCustomReportButtons.length > 0
                        ? _c("div", { staticClass: "seperator" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "w-dropdown-select-item",
                          attrs: { tabindex: "0" },
                          on: {
                            click: function ($event) {
                              return _vm.openCustomReportModal()
                            },
                          },
                        },
                        [
                          _c(
                            "w-row",
                            { attrs: { center: "" } },
                            [
                              _c("w-fa", {
                                staticClass: "mr",
                                attrs: { icon: "plus" },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.$ct("custom-report")) + " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.reportExtraButtons, function (button, i) {
                        return _c(
                          "div",
                          {
                            key: "extra-" + i,
                            staticClass: "w-dropdown-select-item",
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return button.value()
                              },
                            },
                          },
                          [
                            _c(
                              "w-row",
                              { attrs: { center: "" } },
                              [
                                _c("w-fa", {
                                  staticClass: "mr",
                                  attrs: { icon: button.icon },
                                }),
                                _vm._v(" " + _vm._s(button.text) + " "),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.activeCustomReportButton
            ? _c("app-custom-button-modal", {
                attrs: {
                  button: _vm.activeCustomReportButton,
                  model:
                    _vm.state.selectedItems.length > 0
                      ? _vm.state.selectedItems
                      : null,
                },
                model: {
                  value: _vm.showCustomReportButtonModal,
                  callback: function ($$v) {
                    _vm.showCustomReportButtonModal = $$v
                  },
                  expression: "showCustomReportButtonModal",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }